/**
 *
 *  CalendarDay
 *  TruBe Date Time CalendarDay Component
 *
 *  Created by Vladimir Shishlyannikov on 28/02/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React, { useCallback } from "react";

// Hooks
import useContentScrollerItem from "../../../hooks/useContentScrollerItem/useContentScrollerItem";

export default function CalendarDay({
  calendarUid,
  children,
  contentScrollerApi,
  css,
  day,
  daySize,
  isFocused,
  isOutsideDay,
  modifiers,
  isContentScrollerVisible,
  itemKey,
  onDayVisible,
  onDayVisibleChange,
  onDayClick,
  tabIndex,
}) {
  const calendarDayRef = React.useRef(null);

  const clickHandler = useCallback(
    (e) => {
      onDayClick(day, e);
    },
    [day, onDayClick]
  );

  useContentScrollerItem({
    contentScrollerApi: contentScrollerApi,
    element: calendarDayRef.current,
    isScrollerVisible: isContentScrollerVisible,
    key: itemKey,
    onItemVisible: onDayVisible,
    onItemVisibleChange: onDayVisibleChange,
    threshold: 0.9,
  });

  return (
    <div
      className={
        "calendar-day tbk-rounded-lg tbk-shadow-trube hover:tbk-shadow-none"
      }
      role={"button"}
      ref={calendarDayRef}
      // aria-disabled={}
      // aria-label={`${} ${ || ''}`}
      onClick={clickHandler}
      children={[children]}
    />
  );
}
